import { GlobalStylesProps as StyledGlobalStylesProps } from '@mui/styled-engine/GlobalStyles/GlobalStyles';

export const GLOBAL_STYLES: StyledGlobalStylesProps['styles'] = {
    html: {
        fontSize: '62.5%',
        WebkitFontSmoothing: 'antialiased', // Antialiasing.
        MozOsxFontSmoothing: 'grayscale', // Antialiasing.
        boxSizing: 'border-box',
    },

    'html, body': {
        height: '100%',
        width: '100%',
        margin: '0',
    },

    '#root': {
        height: '100%',
    },

    '*, *::before, *::after': {
        boxSizing: 'border-box',
        margin: '0',
        padding: '0',
    },

    '.MuiDataGrid-overlay': {
        zIndex: 999,
        backgroundColor: 'inherit',
    },

    '.MuiDataGrid-root .MuiDataGrid-columnsContainer': {
        borderTop: '0.1rem solid hsl(0deg 0% 93%)',
        borderBottom: '0.1rem solid hsl(0deg 0% 93%)',
    },

    '.MuiBadge-colorPrimary': {
        color: 'white !important',
    },

    '.MuiSelect-select.Mui-disabled': {
        cursor: 'not-allowed !important',
    },
};
